import { useStartAPetitionPageData } from '#src/app/pages/startAPetitionV2/pageContext';

type UseLoadingReturn = ModelHookResult<{
	/**
	 * EU AI Act Art. 50 disclosure heading, carried per locale by the experiment's FCM. Undefined
	 * only in states this variant shouldn't render in (fallback resolutions) — the component then
	 * falls back to the control screen's translated heading.
	 */
	aiLoadingHeading: string | undefined;
}>;

export function useLoading(): UseLoadingReturn {
	const { data } = useStartAPetitionPageData();

	return { data: { aiLoadingHeading: data.experiments.sapAiTextLabeling.config.copy?.loadingHeading } };
}
